import React, { Component } from 'react'
import { Menu, Image, Header, Button } from 'semantic-ui-react';
import { connect } from "react-redux";
import * as actions from "./../actions";
import authObj from './../lib/auth';
import { Link } from 'react-router-dom';

class AppHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        authObj.load().then(() => {
            this.setState({
                isLoggedIn: true
            })
        });
    }

    updateDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentWillMount() {
        // this.updateDimensions();
    }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    signIn() {
        authObj.load(true).then(() => {
            this.setState({
                isLoggedIn: true
            })
        });
    }

    signOut() {
        authObj.signOut()
    }

    render() {
        let element = (<Image src={'https://static.cctech.co.in/prod/images/common/cctech-logo/CCTech-Research-Logo-Header.svg'} style={{ 'height': '40px' }} />);
        if (this.state.width <= 767) {
            element = (<Image src={'https://www.cctech.co.in/assets/images/cctech-logo/CCTech-Logo-500x500.png'} style={{ 'height': '40px' }} />);
        }

        let accountActionBtn = 'Sign in';
        if (this.props.app.loginState) {
            accountActionBtn = this.props.app.loginState.identity.given_name + ', Sign out'
        }


        return (
            <Menu fixed='top'>
                <Menu.Item href={process.env.REACT_APP_EXP_URL}>
                    {element}
                </Menu.Item>

                <Menu.Item position='right'>
                    <Header>
                        <Link to="/">
                            {(this.state.width <= 767) ? 'AI' : 'Autonomous'} Mesh Segmentation
                        </Link>
                    </Header>
                </Menu.Item>
                <Menu.Item>
                    { this.props.app.loginState ?
                        (<Button primary onClick={this.signOut.bind(this)}>{accountActionBtn}</Button>) :
                        (<Button primary onClick={this.signIn.bind(this)}>{accountActionBtn}</Button>)
                    }

                </Menu.Item>
            </Menu>
        );
    }
}

const mapStateToProps = ({ app }) => ({
    app,
});

export default connect(mapStateToProps, actions)(AppHeader);